"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const standard_1 = __importDefault(require("./standard"));
const chrome_colors_1 = require("../common/chrome-colors");
class ChromeFormatter extends standard_1.default {
    constructor(deps) {
        const options = deps.options || {};
        super({
            colorize: chrome_colors_1.colorize,
            options: Object.assign({
                colors: false
            }, options)
        });
    }
    getChromeColors(obj) {
        return this.options.colors ? chrome_colors_1.getChromeColors(obj.level) : [];
    }
}
exports.default = ChromeFormatter;
//# sourceMappingURL=chrome.js.map